export const referralCommissionReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_REFERRAL_COMMISSION_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        referralCommissions: null,
      };
    case "GET_REFERRAL_COMMISSION_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        referralCommissions: action.payload,
      };
    case "GET_REFERRAL_COMMISSION_LIST_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    
    // NEW: Handle single referral commission fetch
    case "GET_REFERRAL_COMMISSION_REQUEST":
      return {
        ...state,
        loading: true,
        referralCommission: null,
      };
    case "GET_REFERRAL_COMMISSION_SUCCESS":
      return {
        ...state,
        loading: false,
        referralCommission: action.payload,
      };
    case "GET_REFERRAL_COMMISSION_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
